import React, { useState, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { withStyles, Typography } from "@material-ui/core";
import { hasPermission, createHistory, formatDate, parseURL } from '../../../sc-utilities';
import { Redirect } from 'react-router-dom';
import TopupHistoryList from './TopupHistoryList';

const styles = (theme) => ({
    root: {
        height: 'auto',
        paddingRight: theme.spacing(-1),
        padding: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        },
    }
});


const TopupHistory = (props) => {
    const tableRef = useRef();
    const { classes, columns, permissions, translations } = props;
    
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, TopupID: null, redirectPath: '' });
    
    const activeAccountID = parseURL(window.location.href).accountID;

    let visible = columns && columns['TopupHistory'];

    const tableColumns = useMemo(() => {
        const unitDefaultFilter = [parseURL(window.location.href).Unit];
        const unitLookup = { 'work': translations['work_erasure'] || "Work Erasure", 'mobile': translations['mobile_erasure'] || 'Mobile Erasure', 'mobile_erasure_lite': translations['mobile_erasure_lite'] || 'Mobile Erasure Lite', 'work_diagnose': translations['work_diagnose'] || 'Work Diagnose', 'work_check': translations['work_check'] || 'Work Check', 'mobile_diagnose': translations['mobile_diagnose'] || 'Mobile Diagnose', 'mobile_check': translations['mobile_check'] || 'Mobile Check', 'remote': translations['remote'] || "Remote", 'currency': translations['money'] || 'Money', 'work_verifier': translations['work_erasure_verification'] || 'Work Erasure Verification', 'mobile_verifier': translations['mobile_erasure_verification'] || 'Mobile Erasure Verification' };

        return [
            {
                title: translations["credits"] || 'Credits', field: 'Credits',
                hidden: visible ? visible['Credits'] : false,
                filtering: true,
                headerStyle:  { paddingLeft: '2rem' },
                filterCellStyle: {paddingLeft:'2rem'},
                cellStyle: { paddingLeft: '1.5rem' },
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Credits ? rowData?.Credits : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["unit"] || 'Unit', field: 'Unit',
                hidden: visible ? visible['Unit'] : false,
                filtering: true,
                lookup: unitLookup,
                defaultFilter: unitDefaultFilter,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData?.Unit ? (unitLookup[rowData.Unit] || rowData.Unit) : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["created_by"] || 'CreatedBy', field: 'CreatedBy',
                hidden: visible ? visible['CreatedBy'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData?.User?.Username || translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["created_at"] || 'CreatedAt', field: 'CreatedAt',
                hidden: visible ? visible['CreatedAt'] : false,
                filtering: false,
                render: rowData => {
                    return <Typography variant={'caption'}>{formatDate(rowData?.CreatedAt) || translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            }
        ];
    }, [translations, visible]);

    const redirectHandler = (path, TopupID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, TopupID: TopupID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'topup_list') ?
                <TopupHistoryList
                    tableRef={tableRef}
                    activeAccountID={activeAccountID}
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                />
                :
                null}
        </div>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID,
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage || 'en',
        accountID: state?.customer?.customers?.loaded?.Accounts,
        translations: state?.translate?.translations?.activeTranslations || {},
        columns: state?.core?.login?.userSettings?.Columns || null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(TopupHistory));